import DesktopView from './desktop-view';
import MobileView from './mobile-view';

export { DesktopView, MobileView };
